import {
  SET_ANNOUNCEMENTS,
  ADD_ANNOUNCEMENT,
  UPDATE_ANNOUNCEMENT,
  REMOVE_ANNOUNCEMENT,
  SET_META,
  SET_UI_FLAG,
} from './types';

export const mutations = {
  [SET_ANNOUNCEMENTS](state, announcements) {
    state.records = announcements;
  },
  [ADD_ANNOUNCEMENT](state, announcement) {
    // Avoid duplicates
    const exists = state.records.find(a => a.id === announcement.id);
    if (!exists) {
      state.records = [announcement, ...state.records];
      state.meta.unreadCount = state.records.length;
    }
  },
  [UPDATE_ANNOUNCEMENT](state, announcement) {
    const index = state.records.findIndex(a => a.id === announcement.id);
    if (index !== -1) {
      state.records.splice(index, 1, announcement);
    }
  },
  [REMOVE_ANNOUNCEMENT](state, announcementId) {
    state.records = state.records.filter(a => a.id !== announcementId);
    state.meta.unreadCount = state.records.length;
  },
  [SET_META](state, meta) {
    state.meta = {
      ...state.meta,
      ...meta,
    };
  },
  [SET_UI_FLAG](state, uiFlags) {
    state.uiFlags = {
      ...state.uiFlags,
      ...uiFlags,
    };
  },
};
